module.exports = __webpack_public_path__ + "static/21-09-28_11-49-53_CA13-6c74c1bda2a1ba6d6858efc6b754954e.jpg";